module.exports = __webpack_public_path__ + "static/media/Credits-38.d1a1ca1e.pdf";